Ext.define('SA.ExportWindow', {
    alias: 'widget.export-window',
    extend: 'SA.view.SimpleContainer',

    autoRender: true,
    autoShow: true,
    cls: 'sa-export-window',

    initComponent() {
        this.items = [
            {
                xtype: 'simple-container',
                cls: 'sa-export-window-header',
                items: [
                    {
                        xtype: 'component',
                        html: Ext.String.htmlEncode(this.config.getExportWindowTitle())
                    }, {
                        xtype: 'component',
                        html: '<svg class="sa-export-window-header-close-button"><use href="#sa-icon-close"></use></svg>',
                        itemId: 'closeButton'
                    }
                ]
            }, {
                xtype: 'export-widget',
                config: this.config
            }
        ];

        this.callParent();

        this.closeButton = this.down('#closeButton');
        this.exportWidget = this.down('export-widget');
    },

    initEvents() {
        this.callParent();

        this.mon(Ext.getDoc(), 'mousedown', this.onDocMouseDown, this);

        this.exportWidget.on('click:cancel', this.destroy, this);
        this.exportWidget.on('click:export', this.destroy, this);

        this.closeButton.getEl().on('click', this.destroy, this);
    },

    onDocMouseDown(ev) {
        if (!this.getEl().dom.contains(ev.getTarget()) && this.config.canHideWindow()) {
            this.destroy();
        }
    }
});